<template>
    <div class="container-fluid">
        <div style="margin-bottom: 6px">
            <div align="left">
                <el-input class="col-lg-3 col-md-4 col-sm-5 col-5" v-model="searchForm.email" placeholder="User email"></el-input>
                <el-input class="col-lg-3 col-md-4 col-sm-6 col-5" v-model="searchForm.crafite_uuid" placeholder="Craftie ID"></el-input>
                <el-button @click="search()">Search</el-button>
            </div>
            <div>
                <div style="float: left; margin-top: 6px; margin-bottom: 6px">
                    <b>{{ total }}</b> Users
                </div>
                <div style="float: right; margin-top: 6px; margin-bottom: 6px">
                    <button class="btn btn-sm btn-primary" @click="toAdd()"> New User </button>
                </div>
            </div>
            <el-table v-tb-height="{ bottom: 40, self: this }" :height="height" stripe  border :data="list" empty-text="Temporarily no data">
                <el-table-column prop="email" label="User(email)"></el-table-column>
                <el-table-column label="Device">
                    <template slot-scope="scope">
                        <template v-for="device of scope.row.device_list">
                            <div :key="device.device_id">
                                {{ device.device_id }}
                                <template v-if="device.status == 0">
                                (<a style="color: deepskyblue" @click="active(scope.row.admin_user_id, device)">waiting...</a>)
                                </template>
                            </div>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column label="Craftie">
                    <template slot-scope="scope">
                        <template v-for="craftie of scope.row.craftie_list">
                            <div :key="craftie.crafite_uuid">
                                {{ craftie.crafite_name }}
                            </div>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column min-width="100px" label="Operator">
                    <template slot-scope="scope">
                        <a v-on:click="toUpdate(scope.row)"><i class="el-icon-s-data update"></i>Update</a>
                        <a v-if="user_type!=6" v-on:click="toDelete(scope.row)"><i class="el-icon-delete delete"></i>Delete</a>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div align="right">
            <div class="block">
                <el-pagination @current-change="handleCurrentChange" layout="prev, pager, next" :page-size="pageSize" :current-page="currentPage" :total="total"></el-pagination>
            </div>
        </div>

        <el-dialog
            title="Add User"
            :visible.sync="addVisible"
            :fullscreen="false"
            width="450px"
            top="10vh"
            :destroy-on-close="true"
            :show-close="true"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
        >
            <CraftieIDWriteAdd v-if="addVisible" @closeDialog="addVisible = false" @dialogSucc="addSucc"></CraftieIDWriteAdd>
        </el-dialog>
        <el-dialog
            title="Update User"
            :visible.sync="editVisible"
            :fullscreen="false"
            width="450px"
            top="10vh"
            :destroy-on-close="true"
            :show-close="true"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
        >
            <CraftieIDWriteUpdate v-if="editVisible" :chooseItem="chooseItem" @closeDialog="editVisible = false" @dialogSucc="editSucc"></CraftieIDWriteUpdate>
        </el-dialog>
    </div>
</template>

<script>
import CraftieIDWriteAdd from "./CraftieIDWriteAdd";
import CraftieIDWriteUpdate from "./CraftieIDWriteUpdate";

export default {
    name: "CraftieIDWrite",
    components: { CraftieIDWriteAdd, CraftieIDWriteUpdate },
    data() {
        return {
            searchForm: {
                email: '',
                crafite_uuid: ''
            },
            user_type: 0,
            list: [],
            timer: 0,
            addVisible: false,
            editVisible: false,
            chooseId: 0,
            chooseItem: null,
            currentPage: 1,
            pageSize: 20,
            total: 0,
            height: 0,
        };
    },
    created() {
        this.getData();
        this.user_type = this.$util.fetch('user_type');
    },
    mounted() {},
    methods: {
        getData() {
            const params = {
                email:this.searchForm.email,
                crafite_uuid:this.searchForm.crafite_uuid,
                page: this.currentPage,
                size: this.pageSize,
            }

            this.$api.rootV1.post(
                "/web/admin/writecrafiteid/get",
                params,
                (res) => {
                    console.log("craftieIDWrite res:", res);
                    this.list = res.data;
                    this.total = res.totalCount * 1;
                }
            ),
            (res) => {};
        },
        search() {
            this.currentPage = 1;
            this.getData()
        },
        active(admin_user_id, device) {
            let loading = this.$util.loading();
            this.$api.rootV1.post(
                "/web/adminuserdevice",
                {
                    admin_user_id: admin_user_id,
                    device_id: device.device_id,
                    status: 1,
                },
                () => {
                    loading.close();
                    this.$set(device, "status", 1);
                },
                () => { loading.close(); }
            );
        },
        toAdd() {
            this.timer = Date.now();
            this.addVisible = true;
        },
        addSucc() {
            this.addVisible = false;
            this.getData();
        },
        toUpdate(row) {
            this.timer = Date.now();
            this.chooseId = row.version_id;
            this.chooseItem = row;
            this.editVisible = true;
        },
        editSucc() {
            this.editVisible = false;
            this.getData();
        },
        toDelete(row) {
            this.$confirm(
                "This operation will delete the app version, do you want to continue?",
                "prompt",
                {
                    confirmButtonText: "Confirm",
                    cancelButtonText: "Cancel",
                    type: "warning",
                }
            ).then(async () => {
                this.doDelete(row);
            }).catch(() => {
                this.$message({
                    type: "info",
                    message: "cancelled!",
                });
            });
        },
        doDelete(row) {
            let loading = this.$util.loading();
            this.$api.rootV1.post(
                "/web/admin/writecrafiteid/delete",
                { admin_user_id: row.admin_user_id },
                (res) => {
                    this.$message.success("successfully deleted!");
                    this.getData();
                    loading.close();
                },
                (res) => {
                    this.$message.error("failed to delete!");
                    loading.close();
                }
            );
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
            this.currentPage = val;
            this.getData();
        },
        setHeight() {
            this.$nextTick(() => {
                if ( document.documentElement.clientHeight < document.getElementById("table").offsetTop + 300 ) {
                    this.height = 240;
                } else {
                    this.height = document.documentElement.clientHeight - document.getElementById("table").offsetTop - 60;
                }
            });
        },
    },
    watch: {},
};
</script>

<style scoped>
.a {
    position: relative;
    left: 10px;
}
.operator {
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/main/craftieIdWrite/CraftieIDWrite.vue